
import { computed, ref, watch } from '@vue/composition-api';
import LazyHydrate from 'vue-lazy-hydration';
import { Button } from '05-ui-kit';
import cloneDeep from 'lodash.clonedeep';
import type { FilterGroup } from '~/type/Filter';
interface Props {
  loading: boolean;
  list: FilterGroup[];
  type?: 'catalog' | 'search';
  /*
  Параметры активных фильтров
  */
  value: {
    [key: string]: string;
  };
}

/**
 * Проверяем есть ли основные фильтры для скрытия кнопки раскрытия дополнительных фильтров
 */
const __sfc_main = {};
__sfc_main.props = {
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'catalog'
  },
  value: {
    key: "value",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const isBasic = computed(() => {
    return props.list.every(el => el.isMain === true);
  });
  const showAllFilters = ref(false);
  const innerValue = ref(cloneDeep(props.value));
  watch(() => props.value, value => {
    innerValue.value = value;
  }, {
    deep: true
  });
  function change({
    property,
    value
  }: {
    property: string;
    value: string;
  }) {
    if (!value && innerValue.value[property]) delete innerValue.value[property];else innerValue.value[property] = value;
    checkZeroPrice();
    emit('change', cloneDeep(innerValue.value));
  }
  function checkZeroPrice() {
    /*
    * Если при изменении Range фильтра с бэка приходит нулевая цена, то не добавляем её в запросы
    */
    if (innerValue.value.price_to === '0') delete innerValue.value.price_to;
    if (innerValue.value.price_from === '0') delete innerValue.value.price_from;
  }
  function submit() {
    checkZeroPrice();
    /**
    * Срабатывает при применении фильтров в мобильной версии
    */
    emit('submit', cloneDeep(innerValue.value));
  }
  function reset() {
    /**
    * Срабатывает изменении фильтров
    */
    emit('change', {});
  }
  return {
    isBasic,
    showAllFilters,
    innerValue,
    change,
    submit,
    reset
  };
};
__sfc_main.components = Object.assign({
  LazyHydrate,
  Button
}, __sfc_main.components);
export default __sfc_main;
